import { get, post, put, patch } from "../Config"

export function SearchFooter({ params = {}, lang }) {
  return get({ url: `/v1/admin/footer`, params, lang })
}
export function GetFooterById({ id, lang }) {
  return get({ url: `/v1/admin/footer/${id}`, lang })
}
export function CreateFooter({ params = {}, data = {}, lang }) {
  return post({ url: `/v1/admin/footer`, params, data, lang })
}
export function UpdateFooter({ params = {}, data = {} , id, lang }) {
  return put({ url: `/v1/admin/footer/${id}`, params, data, lang })
}
export function PatchFooter({ params = {}, data = {} , id, lang }) {
  return patch({ url: `/v1/admin/footer/${id}`, params, data, lang })
}
export function DeleteFooter({ params = {}, data = {}, lang }) {
  return post({ url: `/v1/admin/footer/mutiDelete`, params, data, lang })
}
